import React from "react";
import { Mail, PackageSearch } from "lucide-react";
import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import QuickQuoteForm from "@/components/QuickQuoteForm";
import { CONTACT_EMAIL, IMG } from "@/lib/siteData";
import { useLang } from "@/context/LangContext";

export default function ContactPage() {
    const { t } = useLang();
    return (
        <>
            <PageHero testid="contact-hero" eyebrow="Contact" img={IMG.road} title={t("Parlons de votre projet", "Let's talk about your project")}
                text={t("Une question, un besoin de transport ? Écrivez-nous, notre équipe vous répond rapidement.", "A question or a transport need? Write to us and our team will reply quickly.")} />
            <section className="max-w-6xl mx-auto px-5 lg:px-8 py-16 grid lg:grid-cols-[1fr_1.2fr] gap-10">
                <div className="space-y-5">
                    <a href={`mailto:${CONTACT_EMAIL}`} data-testid="contact-email-link" className="flex items-center gap-4 border border-slate-200 rounded-md p-5 hover:border-[#f26b1d] transition-colors">
                        <Mail size={26} className="text-[#f26b1d]" />
                        <div><div className="text-xs text-slate-500">Email</div><div className="font-semibold">{CONTACT_EMAIL}</div></div>
                    </a>
                    <Link to="/suivi" data-testid="contact-tracking-link" className="flex items-center gap-4 border border-slate-200 rounded-md p-5 hover:border-[#f26b1d] transition-colors">
                        <PackageSearch size={26} className="text-[#f26b1d]" />
                        <div><div className="text-xs text-slate-500">{t("Déjà client ?", "Already a client?")}</div><div className="font-semibold">{t("Suivre une expédition", "Track a shipment")}</div></div>
                    </Link>
                </div>
                <div className="bg-[#0b2545] rounded-md p-6 lg:p-8">
                    <h2 className="font-display text-2xl font-bold text-slate-50 mb-5">{t("Envoyez-nous un message", "Send us a message")}</h2>
                    <QuickQuoteForm kind="Contact" testid="contact" subject />
                </div>
            </section>
        </>
    );
}
